const MONTH_DAY_YEAR = /^([A-Za-z]+)\s+(\d{1,2}),\s+(\d{4})$/;

export const formatPromoEndDate = (date: string, locale: string): string => {
  const trimmed = date.trim();
  if (!trimmed) {
    return date;
  }

  const namedMonth = MONTH_DAY_YEAR.exec(trimmed);
  const parsed = namedMonth
    ? Date.parse(`${namedMonth[1]} ${namedMonth[2]}, ${namedMonth[3]} 12:00:00`)
    : Date.parse(trimmed);

  if (Number.isNaN(parsed)) {
    return date;
  }

  return new Intl.DateTimeFormat(locale === "es" ? "es" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(parsed));
};
